// tslint:disable
/**
 * Property Management
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum WaterFlowEventType {
  UNSET = 'UNSET',
  FLOWSTART = 'FLOW_START',
  NOFLOW = 'NO_FLOW',
  CONTINUOUSLEAKDETECTED = 'CONTINUOUS_LEAK_DETECTED',
  CYCLINGLEAKDETECTED = 'CYCLING_LEAK_DETECTED',
  BATTERYLEVELCHANGED = 'BATTERY_LEVEL_CHANGED',
  CONTINUOUSLEAKENDED = 'CONTINUOUS_LEAK_ENDED',
  CYCLINGLEAKENDED = 'CYCLING_LEAK_ENDED',
}
